import React, { useState } from "react";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../Components/Firebase/firebaseConfig";

function SendData() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [nationalId, setNationalId] = useState('');
  const [phone, setPhone] = useState('');
  const [shipmentType, setShipmentType] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Use nationalId as the document ID
      await setDoc(doc(db, "shipments", nationalId), {
        name,
        email,
        nationalId,
        phone,
        shipmentType,
        timestamp: serverTimestamp()
      });
      alert('تم إرسال البيانات بنجاح');
      // Clear form fields after submission
      setName('');
      setEmail('');
      setNationalId('');
      setPhone('');
      setShipmentType('');
    } catch (error) {
      alert('حدث خطأ أثناء إرسال البيانات: ' + error.message);
    }
  };

  return (
    <section className="SendData">
      <div className="container mt-5 ">
        <h2 className="text-center">
          املاء البيانات للحجز معنا وتتبع شحنتك بسهولة{" "}
        </h2>

        <form className="w-75 m-auto" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">
              <i className="fas fa-user text-danger fs-5 my-2 "></i> الاسم
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="أدخل اسمك "
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">
              <i className="fas fa-envelope text-danger fs-5 my-2"></i> الايميل
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="ادخل الايميل"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="nationalId">
              <i className="fa-solid fa-id-card text-danger fs-5 my-2"></i> رقم القومي
            </label>
            <input
              type="text"
              className="form-control"
              id="nationalId"
              placeholder="الرقم القومي "
              value={nationalId}
              onChange={(e) => setNationalId(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">
              <i className="fas fa-phone text-danger fs-5 my-2"></i> رقم الموبيل
            </label>
            <input
              type="text"
              className="form-control"
              id="phone"
              placeholder="الموبيل"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="shipmentType">
              <i className="fas fa-comment text-danger fs-5 my-2"></i> نوع الشحنة
            </label>
            <textarea
              className="form-control"
              id="shipmentType"
              rows="3"
              placeholder="نوع الشحنة"
              value={shipmentType}
              onChange={(e) => setShipmentType(e.target.value)}
            ></textarea>
          </div>

          <button type="submit" className="btn btn-danger my-3">
            <i className="fas fa-paper-plane"></i> ارسال
          </button>
        </form>
      </div>
    </section>
  );
}

export default SendData;
